"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGoogleMapValues = exports.getContactValue = exports.getLocationDisplayAddress = exports.getSortedLocations = exports.getLocationHeadersForProvider = void 0;
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const types_1 = require("../../types");
const globals_1 = require("./constants/globals");
/**
 * Method to determine what headers are needed for location data
 * @param {ProviderMatchProviderLocationV9[]} locations The location data for a provider to create headers for
 * @param {boolean} shouldDisplayFaxNumber Indicates whether or not to show a fax number for a location
 * @return {Record<LocationHeader, boolean>} An object indicating which headers are enabled
 */
const getLocationHeadersForProvider = (locations, shouldDisplayFaxNumber) => {
    const headers = globals_1.ALL_LOCATION_HEADERS.reduce((accum, curr) => (Object.assign(Object.assign({}, accum), { [curr]: false })), {});
    for (const header of globals_1.ALL_LOCATION_HEADERS) {
        if (header === types_1.LOCATION_HEADER.FAX && !shouldDisplayFaxNumber) {
            headers[header] = false;
        }
        else if (locations.some((location) => {
            return (!!location[header] ||
                (header === types_1.LOCATION_HEADER.PHONE &&
                    (0, exports.getContactValue)(location, {
                        primary: types_1.CONTACT_TYPE.PMC_PHONE,
                        secondary: types_1.CONTACT_TYPE.PHONE
                    })) ||
                (header === types_1.LOCATION_HEADER.FAX &&
                    (0, exports.getContactValue)(location, {
                        primary: types_1.CONTACT_TYPE.PMC_FAX,
                        secondary: types_1.CONTACT_TYPE.FAX
                    })));
        })) {
            headers[header] = true;
        }
    }
    return headers;
};
exports.getLocationHeadersForProvider = getLocationHeadersForProvider;
/**
 * Sort locations by rank, distance, and then name.
 * @param {ProviderMatchProviderLocationV9[]} locations The locations to sort
 * @return {ProviderMatchProviderLocationV9[]} The sorted location array
 */
const getSortedLocations = (locations, prioritizeDistance) => {
    return prioritizeDistance
        ? (0, sortBy_1.default)(locations, ['distance', 'rank', 'name'])
        : (0, sortBy_1.default)(locations, ['rank', 'distance', 'name']);
};
exports.getSortedLocations = getSortedLocations;
/**
 * Gets a displayable address string for a location
 * @param {ProviderMatchProviderLocationV9} location The location to get the display address for.
 * @return {string} Display friendly address string
 */
const getLocationDisplayAddress = (location) => {
    const street2 = location.street2 ? location.street2 + ', ' : '';
    const suite = location.suite ? location.suite + ', ' : '';
    return `${location.street1}, ${street2}${suite}${location.city}, ${location.state} ${location.zip}`;
};
exports.getLocationDisplayAddress = getLocationDisplayAddress;
/**
 * Get the contact value for a location if possible
 * @param {ProviderLocation} location The location to get the contact value for
 * @param {{ primary: ContactType; secondary: ContactType; }} contactType The contact type to retrieve
 * @return {string || null} The proper contact value if found, null if not
 */
const getContactValue = (location, contactType) => {
    var _a, _b, _c, _d, _e;
    return ((_e = (_d = (_c = (_b = (_a = location.contacts) === null || _a === void 0 ? void 0 : _a.find((contact) => { var _a; return ((_a = contact.type) !== null && _a !== void 0 ? _a : contact.contact_type) === contactType.primary; })) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : location[contactType.primary]) !== null && _d !== void 0 ? _d : location[contactType.secondary]) !== null && _e !== void 0 ? _e : null);
};
exports.getContactValue = getContactValue;
/**
 * Get a google map or direction link
 * @param {ProviderLocation} location The location to get the google maps link for.
 * @param {string || undefined} searchedLocation The location user may have searched to find Providers around.
 * @return {GoogleMapsMetaData} An object containing the google maps link and the location string used to get it.
 */
const getGoogleMapValues = (location, searchedLocation) => {
    // Create URI component
    const locationUriComponent = globals_1.MAP_LOCATION_FIELDS.filter((field) => location[field])
        .map((field) => location[field])
        .filter((field) => !!field)
        .join(', ');
    const locationName = location.exterior_signage_name || location.name;
    const locationURI = encodeURIComponent(locationName
        ? `${locationName}, ${locationUriComponent}`
        : locationUriComponent);
    let mapHref;
    if (searchedLocation) {
        mapHref = `${globals_1.MAP_BASE_URL}/dir/?api=1&query=${encodeURIComponent(searchedLocation)}/${locationURI}/`;
    }
    else {
        mapHref = `${globals_1.MAP_BASE_URL}/search/?api=1&query=${locationURI}/`;
    }
    return {
        href: mapHref,
        locationString: locationName
            ? `${locationName}, ${locationUriComponent}`
            : locationUriComponent
    };
};
exports.getGoogleMapValues = getGoogleMapValues;
//# sourceMappingURL=location.js.map